// Tab section start
$(document).ready(function() {

    const $tabs = $("tabes-section .tabs .tab-link");
    const $contents = $("tabes-section .tab-content");

    // Set first available tab & content as active
    if ($tabs.length > 0 && $contents.length > 0) {
        $tabs.first().addClass("current");
        $contents.first().addClass("current");
    }

    $('.tabes-section ul.tabs li').click(function() {
        var tab_id = $(this).attr('data-tab');

        $('.tabes-section ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    })

});
// Tab section end

// about page video start
$(document).ready(function () {

  $(".video-container").each(function () {
    let container = $(this);

    let youtubeIframe = container.find("iframe")[0];
    let normalVideo = container.find("video")[0];
    let thumb = container.find(".thumbnail");
    let playBtn = container.find(".play-button");

    // ---------- CLICK TO PLAY ----------
    thumb.add(playBtn).on("click", function () {

      thumb.hide();
      playBtn.hide();

      // YouTube Play
      if (youtubeIframe) {
        let src = youtubeIframe.src;
        if (!src.includes("autoplay=1")) {
          youtubeIframe.src = src + "&autoplay=1";
        }
      }

      // Normal Video Play
      if (normalVideo) {
        normalVideo.play();
      }
    });

    // ---------- NORMAL VIDEO PAUSE ----------
    if (normalVideo) {
      normalVideo.addEventListener("pause", function () {
        thumb.show();
        playBtn.show();
      });

      normalVideo.addEventListener("ended", function () {
        thumb.show();
        playBtn.show();
      });
    }

    // ---------- YOUTUBE PAUSE DETECT ----------
    if (youtubeIframe) {
      // Wait for YouTube API ready
      let tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      window.onYouTubeIframeAPIReady = function () {
        let player = new YT.Player(youtubeIframe, {
          events: {
            onStateChange: function (event) {
              // 2 = paused, 0 = ended
              if (event.data === 2 || event.data === 0) {
                thumb.show();
                playBtn.show();
              }
            }
          }
        });
      };
    }

  });

});
// about page video end



// banner-slider start
const bannerslider = new Swiper(".banner-slider-inner", {
  loop: true,
  speed: 800,
  autoplay: {
    delay: 3000,
  },
   autoplay:false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});
// banner-slider end



// passion-slider start
const passionslider = new Swiper(".passion-slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay:true,
    navigation: {
      nextEl: ".swiper2-button-next",
      prevEl: ".swiper2-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
      },
      1280: {
        slidesPerView: 1.59,
      },
    },
  });
// passion-slider end


// quality slider start
const qualityslider = new Swiper('.quality-slider', {
  slidesPerView: 4.7,
  spaceBetween: 0,
  slidesPerView: 'auto',
  loop: true,
  speed: 4000, // slower = smoother continuous movement
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  freeMode: {
    enabled: false,
    momentum: false,
  },
  grabCursor: false,
  breakpoints: {
    768: {
      slidesPerView: 4.7,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 4.7,
      spaceBetween: 0,
    },
    1500: {
      slidesPerView: 6.2,
      spaceBetween: 0,
    },
  },
});
// quality slider end

// logo slider start
const logoslider = new Swiper('.logo-slider', {
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  speed: 6000, // slower = smoother continuous movement
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  freeMode: {
    enabled: false,
    momentum: false,
  },
  grabCursor: false,
  breakpoints: {
       400: {
      slidesPerView:  4,
      spaceBetween: 40,
    },
    768: {
      slidesPerView:  5,
      spaceBetween: 50,
    },
    992: {
      slidesPerView:  7,
      spaceBetween: 60,
    },
    1500: {
      slidesPerView: 8,
      spaceBetween: 70,
    },
  },
});

// logo slider end



// Added By MS
$(document).ready(function() {

  const $tocContainer = $('.blog_toc ul');
  const $content = $('.article-template__content');
  if (!$tocContainer.length || !$content.length) return false;

  const $headings = $content.find('h2, h3, b, strong');
  if ($headings.length) {
    let tocHTML = '';
    $headings.each(function(i) {

      const text = $(this).text().trim();
      
      // skip empty headings
      if (!text) return; 

      const id = 'section-' + i;
      $(this).attr('id', id);
      tocHTML += `<li><a href="#${id}" class="body_m toc_link">${$(this).text()}</a></li>`;
    });
    $tocContainer.html(tocHTML);
  }else{
    $('.blog_toc').hide();
  }

      $('.toc_link').click(function (e) {
      e.preventDefault();
      var target = $($(this).attr('href'));
      if (target.length) {
        var scrollTo = target.offset().top - 110;
        // $('.toc_link').removeClass('active');
        $(".blog_toc ul li").removeClass('active');
        $(this).parent().addClass('active');
        $('body, html').animate({ scrollTop: scrollTo }, 800);
      }
    });



  $(".article-template .content_wrapper p").each(function () {
  const $p = $(this);

  // Remove empty spans, whitespace-only spans, and spans containing &nbsp;
  $p.find("span").each(function () {
    const spanText = $(this).text().replace(/\u00a0/g, "").trim();

    if (spanText === "" && $(this).children().length === 0) {
      $(this).remove(); // remove useless span
    }
  });

  // After cleaning spans, re-check if p is empty
  const cleanedText = $p.text().replace(/\u00a0/g, "").trim();

  if (cleanedText === "" && $p.children().length === 0) {
    $p.css({ display: "none", margin: 0 });
  }
});








});



// Copy Promocode section on product page Start
$('.copy-icon-btn').on("click", function (e) {
    e.preventDefault();

    $('.copy-icon-btn').removeClass("copied");
    let promo_code = $(this).data("promo-code");
    
    // Create a temporary input
    const temp = $("<input>");
    
    $("body").append(temp);
    
    temp.val(promo_code).select();
    document.execCommand("copy");
    
    temp.remove();
    $(this).addClass("copied");
    alert("Copied!!");
});

// Copy Promocode section on product page END




